const footer = `<p style="color:#787878;font-size:11px">
<br>
__________________________________________________________<br>
<br>
Copyright &#169; ${(new Date()).getFullYear()} ${process.env.REACT_APP_DOMAIN}. All rights reserved.<br>Sent by ${process.env.REACT_APP_DOMAIN} | B-8, Sector 132,  Noida - 201304.
<br><br>
You are receiving this email because you are registered to ${process.env.REACT_APP_DOMAIN}.
</p>`;

export default footer;